import moment from 'moment';
import momentTz from 'moment-timezone';

import { signOut, getAuth } from 'firebase/auth';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as userMgtConstant from '../store/actions/actionTypes';


export function CalculateUserTzToUTCTz(dtVal) {
    const dateTime = moment(dtVal).format('YYYY-MM-DD HH:mm:ss');
    const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const userTZ =  momentTz.tz(dateTime, browserTz);
    const UTCTz =  userTZ.clone().tz("Etc/GMT");
    return UTCTz;
}

export function CalculateUTCTzToUserTz(dtVal) {
    const dateTime = dtVal; 
    if(dateTime){
        const browserTimezone = moment.utc(dtVal).tz(moment.tz.guess()).format('MM/DD/YYYY HH:mm');
        return browserTimezone;
    }
    return '-';
}

export function isValidUSZip(sZip) {
    return /^[1-9]\d*(\.\d+)?$/.test(sZip);
}

export function retriveLanguage(code) {
    const language = {
        en: "English (en)",
        pt: "Portuguese (pt)",
        vi: "Vietnamese (vi)",
        es: "Spanish (es)",
        zh: "Chinese (zh)",
        ht: "Haitian Creole (ht)",
    }
    return language[code];
}

export function splitDate(dtVal) {
    const dateTime = dtVal; 
    if(dateTime){
        const browserTimezone = moment(dateTime).local().format('MM/DD/YYYY HH:mm');
        if(browserTimezone !== "Invalid date"){
            const sDate = browserTimezone.split(" ");
            return sDate[0];
        }
    }
    return '-';
}

export function formatDTADate(unFormattedDate) {
    const monthJson = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec"
    }
    const spilttedDate = unFormattedDate.split('/');
    if(spilttedDate.length === 3){
        const month = monthJson[spilttedDate[0]];
        const day = spilttedDate[1];
        const year = spilttedDate[2];
        return `${day}.${month}.${year}`
    }
    return '-'
}

export function formatDTADateForPicker(unFormattedDate) {
    const monthJson = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec"
    }
    const spilttedDate = unFormattedDate.split('-');
    if(spilttedDate.length === 3){
        const month = monthJson[spilttedDate[0]];
        const day = spilttedDate[1];
        const year = spilttedDate[2];
        return `${day}.${month}.${year}`
    }
    return '-'
}

export function splitTime(dtVal) {
    const dateTime = dtVal; 
    if(dateTime){
        const browserTimezone = moment(dateTime).local().format('MM/DD/YYYY hh:mm a');
        if(browserTimezone !== "Invalid date"){
            const sDate = browserTimezone.split(" ");
            if(sDate){
                return `${sDate[1]} ${sDate[2]?.toUpperCase() || "-"}`;
            }
            return "-";
        }
    }
    return '-';
}

export function getYearMonthFromDate(dtVal) {
    const monthJson = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec"
    }
    const spilttedDate = dtVal.split('/');
    if(spilttedDate.length === 3){
        const month = monthJson[spilttedDate[0]];
        const year = spilttedDate[2];
        return `${month}.${year}`
    }
    return '-'
}

export const trimStringSpace = (str) => {
    return str.replace(/\s+/g,' ').trim();
}

export const containsSpecialCharacters = (str) => {
    // eslint-disable-next-line
    const specialChars = /[`!#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/;
    return specialChars.test(str);
}

export const containsSpecialCharactersGrid = (str) => {
    // eslint-disable-next-line
    const specialChars = /[`!#$%^&*()+\-=\[\]{};':"\\|,<>\/?~]/;
    return specialChars.test(str);
}

export const calculateDaysInDates = (startDate, endDate) => {
    const diffTime = Math.abs(startDate - endDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
}

export const calulateChartView = async (data, lableField) => {
    let finalObject = { lables: [] }
    let lables = [];
    let martinreaFund = [];
    let empoyeeFund = [];
    let martinreaFundCombined = [];
    let empoyeeFundCombined = [];
    let totlaMartirea = 0;
    let totalEmployee = 0;
    let totalHours = 0;
    let totlaMartireaC = 0;
    let totalEmployeeC = 0;
    let totalHoursC = 0;

    data?.forEach((input, index) => {
        const newLable = input[lableField];
        lables?.push([newLable, input?.totalVolunteerHours ? (Intl.NumberFormat().format(input?.totalVolunteerHours) + ' Hrs') : '0 Hrs']);
        totalHours = totalHours + (input?.totalVolunteerHours ? Number(input?.totalVolunteerHours) : 0);
        totalHoursC = totalHoursC + (input?.totalVolunteerHoursCombined ? Number(input?.totalVolunteerHoursCombined) : 0);

        const martinrea = input.totalFunds ? Number(Number(input.totalFunds).toFixed(2)) : 0;
        const employee = input.employeeFunds ? Number(Number(input.employeeFunds).toFixed(2)) : 0;
        const martinreaCombined = input.totalFundsCombined ? Number(Number(input.totalFundsCombined).toFixed(2)) : 0;
        const employeeCombined = input.employeeFundsCombined ? Number(Number(input.employeeFundsCombined).toFixed(2)) : 0;

        martinreaFund.push(martinrea);
        empoyeeFund.push(employee);
        martinreaFundCombined.push(martinreaCombined);
        empoyeeFundCombined.push(employeeCombined);

        totlaMartirea = totlaMartirea + martinrea;
        totalEmployee = totalEmployee + employee;
        totlaMartireaC = totlaMartireaC + martinreaCombined;
        totalEmployeeC = totalEmployeeC + employeeCombined;
    });

    lables?.push(['Total', totalHours ? (Intl.NumberFormat().format(totalHours) + ' Hrs') : '0 Hrs']);
    martinreaFund.push(totlaMartirea);
    empoyeeFund.push(totalEmployee);
    martinreaFundCombined.push(totlaMartireaC);
    empoyeeFundCombined.push(totalEmployeeC);

    finalObject["labels"] = lables;
    finalObject["martinreaFund"] = martinreaFund;
    finalObject["empoyeeFund"] = empoyeeFund;
    finalObject["martinreaFundCombined"] = martinreaFundCombined;
    finalObject["empoyeeFundCombined"] = empoyeeFundCombined;

    return finalObject;
}

export const calulateTableView = async (data, lableField) => {
    let tableObject = [];
    let totlaMartirea = 0;
    let totalEmployee = 0;
    let totlaHours = 0;
    let totlaMartireaC = 0;
    let totalEmployeeC = 0;
    let totlaHoursC = 0;

    data?.forEach((input, index) => {
        const martinreaFund = input.totalFunds ? Number(input.totalFunds).toFixed(2) : 0;
        const employeedFund = input.employeeFunds ? Number(input.employeeFunds).toFixed(2) : 0;
        const martinreaFundCombined = input.totalFundsCombined ? Number(input.totalFundsCombined).toFixed(2) : 0;
        const employeedFundCombined = input.employeeFundsCombined ? Number(input.employeeFundsCombined).toFixed(2) : 0;
        const volunteerHoursCombined = input.totalVolunteerHoursCombined ? Number(input.totalVolunteerHoursCombined) : 0;

        const rowObject = {
            'country': input[lableField],
            'martinreaFunds': '$ ' + parseFloat(martinreaFund).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            'martinreaFundsCombined': '$ ' + parseFloat(martinreaFundCombined).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            'employeeFunds': '$ ' + parseFloat(employeedFund).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            'employeeFundsCombined': '$ ' + parseFloat(employeedFundCombined).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            'volunteerHour': Intl.NumberFormat().format(input?.totalVolunteerHours) || 0,
            'volunteerHourCombined': Intl.NumberFormat().format(volunteerHoursCombined) || 0
        };
        tableObject.push(rowObject);

        totlaMartirea = totlaMartirea + Number(martinreaFund);
        totalEmployee = totalEmployee + Number(employeedFund);
        totlaHours = totlaHours + (input?.totalVolunteerHours ? Number(input?.totalVolunteerHours) : 0);
        totlaMartireaC = totlaMartireaC + Number(martinreaFundCombined);
        totalEmployeeC = totalEmployeeC + Number(employeedFundCombined);
        totlaHoursC = totlaHoursC + volunteerHoursCombined;
    });

    tableObject.sort((a, b) => {
        const fundA = parseFloat(a.martinreaFunds.replace(/[^0-9.-]+/g, ''));
        const fundB = parseFloat(b.martinreaFunds.replace(/[^0-9.-]+/g, ''));
        return fundB - fundA;
    });

    const rowObject = {
        'country': "Total",
        'martinreaFunds': '$ ' + parseFloat(totlaMartirea).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'martinreaFundsCombined': '$ ' + parseFloat(totlaMartireaC).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'employeeFunds': '$ ' + parseFloat(totalEmployee).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'employeeFundsCombined': '$ ' + parseFloat(totalEmployeeC).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'volunteerHour': Intl.NumberFormat().format(totlaHours),
        'volunteerHourCombined': Intl.NumberFormat().format(totlaHoursC)
    };
    tableObject.push(rowObject);

    return tableObject;
};

export const calulateTableViewForLocation = async (data, lableField) => {
    let tableObject = [];
    let totlaMartirea = 0;
    let totalEmployee = 0;
    let totlaHours = 0;
    let totlaMartireaC = 0;
    let totalEmployeeC = 0;
    let totlaHoursC = 0;
    let localCurrency;

    data?.forEach((input, index) => {
        const martinreaFund = input.totalFunds ? Number(input.totalFunds).toFixed(2) : 0;
        const employeedFund = input.employeeFunds ? Number(input.employeeFunds).toFixed(2) : 0;
        const martinreaLocalFund = input.totalFundsInLocal ? Number(input.totalFundsInLocal).toFixed(2) : 0;
        const employeeLocalFund = input?.employeeFundsInLocal ? Number(input?.employeeFundsInLocal)?.toFixed(2) : 0;
        const martinreaFundCombined = input.totalFundsCombined ? Number(input.totalFundsCombined).toFixed(2) : 0;
        const employeedFundCombined = input.employeeFundsCombined ? Number(input.employeeFundsCombined).toFixed(2) : 0;
        const martinreaLocalFundCombined = input.totalFundsInLocalCombined ? Number(input.totalFundsInLocalCombined).toFixed(2) : 0;
        const employeeLocalFundCombined = input?.employeeFundsInLocalCombined ? Number(input?.employeeFundsInLocalCombined)?.toFixed(2) : 0;
        const volunteerHoursCombined = input.totalVolunteerHoursCombined ? Number(input.totalVolunteerHoursCombined) : 0;
        localCurrency = input.localCurrency ? input.localCurrency?.toUpperCase() : '';

        const rowObject = {
            'country': input[lableField],
            'martinreaFunds': '$ ' + parseFloat(martinreaFund).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            'martinreaFundsCombined': '$ ' + parseFloat(martinreaFundCombined).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            'martinreaFundsInLocal': localCurrency + ' ' + parseFloat(martinreaLocalFund).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            'martinreaFundsInLocalCombined': localCurrency + ' ' + parseFloat(martinreaLocalFundCombined).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            'employeeFunds': '$ ' + parseFloat(employeedFund).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            'employeeFundsCombined': '$ ' + parseFloat(employeedFundCombined).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            'employeeFundsInLocal': localCurrency + ' ' + parseFloat(employeeLocalFund).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            'employeeFundsInLocalCombined': localCurrency + ' ' + parseFloat(employeeLocalFundCombined).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            'volunteerHour': Intl.NumberFormat().format(input?.totalVolunteerHours) || 0,
            'volunteerHourCombined': Intl.NumberFormat().format(volunteerHoursCombined) || 0
        };
        tableObject.push(rowObject);

        totlaMartirea = totlaMartirea + Number(martinreaFund);
        totalEmployee = totalEmployee + Number(employeedFund);
        totlaHours = totlaHours + (input?.totalVolunteerHours ? Number(input?.totalVolunteerHours) : 0);
        totlaMartireaC = totlaMartireaC + Number(martinreaFundCombined);
        totalEmployeeC = totalEmployeeC + Number(employeedFundCombined);
        totlaHoursC = totlaHoursC + volunteerHoursCombined;
    });

    tableObject.sort((a, b) => {
        const fundA = parseFloat(a.martinreaFunds.replace(/[^0-9.-]+/g, ''));
        const fundB = parseFloat(b.martinreaFunds.replace(/[^0-9.-]+/g, ''));
        return fundB - fundA;
    });

    const rowObject = {
        'country': "Total",
        'martinreaFunds': '$ ' + parseFloat(totlaMartirea).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'martinreaFundsCombined': '$ ' + parseFloat(totlaMartireaC).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'martinreaFundsInLocal': '',
        'martinreaFundsInLocalCombined': '',
        'employeeFunds': '$ ' + parseFloat(totalEmployee).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'employeeFundsCombined': '$ ' + parseFloat(totalEmployeeC).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        'employeeFundsInLocal': '',
        'employeeFundsInLocalCombined': '',
        'volunteerHour': Intl.NumberFormat().format(totlaHours),
        'volunteerHourCombined': Intl.NumberFormat().format(totlaHoursC)
    };
    tableObject.push(rowObject);

    return tableObject;
};

export const useLogout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const auth = getAuth();

    const onLogout = async () => {
        const auth = getAuth();
        signOut(auth).then(() => {
            window.localStorage.clear();
            dispatch({
                type: userMgtConstant.RESET_USER_PROFILE,
                payload: null
            });
            navigate('/login');
            window.location.reload();
        }).catch((error) => {});
    };

    return onLogout;
};